// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { arrowUp16X16 } from '@ni/nimble-tokens/dist/icons/js';
import { Icon, registerIcon } from '../icon-base';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-arrow-up': IconArrowUp;
    }
}

/**
 * The icon component for the 'arrowUp' icon
 */
export class IconArrowUp extends Icon {
    public constructor() {
        super(arrowUp16X16);
    }
}

registerIcon('icon-arrow-up', IconArrowUp);
export const iconArrowUpTag = 'nimble-icon-arrow-up';
